module.exports = __webpack_public_path__ + "static/img_pledge_children_02-e30114e958c76fc135618ec1113e287e.png";